import { Horizon, Peeks, splitArt } from './Art';

export default function Press({ heading, quotes, art }) {
  if (!quotes.length) return null;
  const [first, ...others] = quotes;
  const { peeks, horizon } = splitArt(art);
  return (
    <section id="praise" className={`sec sec--sea press ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="press-title">
      <Peeks items={peeks} />
      <div className="wrap">
        <h2 id="press-title" className="display">{heading}</h2>
        <blockquote className="press-lead">
          <p>{first.quote}</p>
          {first.source && <footer>{first.source}</footer>}
        </blockquote>
        {others.length > 0 && (
          <div className="press-grid">
            {others.map((q) => (
              <blockquote key={q.key} className="press-quote">
                <p>{q.quote}</p>
                {q.source && <footer>{q.source}</footer>}
              </blockquote>
            ))}
          </div>
        )}
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
